import { useCallback, useState } from "react";

type JoyrideCallbackInput = {
  status?: string;
  type?: string;
  index?: number;
};

export function useDocumentPortalTour(storageKey: string) {
  const [run, setRun] = useState(false);

  const startTour = useCallback(() => {
    setRun(true);
  }, []);

  const stopTour = useCallback(() => {
    setRun(false);
    if (typeof window !== "undefined") {
      localStorage.setItem(storageKey, "true");
    }
  }, [storageKey]);

  const handleJoyrideCallback = useCallback(
    (data: JoyrideCallbackInput) => {
      const { status, type } = data;
      if (
        status === "finished" ||
        status === "skipped" ||
        type === "tour:end"
      ) {
        stopTour();
      }
    },
    [stopTour],
  );

  return {
    run,
    startTour,
    handleJoyrideCallback,
  };
}
